// eslint-disable-next-line import/prefer-default-export
export const API_URL = process.env.REACT_APP_SERVER_URL;
